module.exports = __webpack_public_path__ + "static/media/MHT10160.6a33b3ec.png";